import React from 'react';
import { Modal, Button } from 'antd';

class MultipleSelect extends React.Component {
  state = {
    selected: []
  };

  componentDidUpdate = prevProps => {
    if (prevProps.field !== this.props.field) {
      this.setState({ selected: this.props.selected });
    }
  };

  getFieldStyle = field => {
    const { color } = this.props;
    if (this.state.selected && this.state.selected.includes(field)) {
      //selected
      return {
        backgroundColor: color,
        color: 'white',
        fontSize: 14,
        padding: '10px 20px 10px 20px',
        border: `1px solid ${color}`,
        borderRadius: 10,
        marginBottom: 10,
        fontSize: 16,
        cursor: 'pointer'
      };
    } else {
      return {
        backgroundColor: 'white',
        color: color,
        border: `1px solid ${color}`,
        fontSize: 14,
        padding: '10px 20px 10px 20px',
        borderRadius: 10,
        marginBottom: 10,
        fontSize: 16,
        cursor: 'pointer'
      };
    }
  };

  changeSelection = field => {
    let { selected } = this.state;
    if (this.state.selected && this.state.selected.includes(field)) {
      //Deselect
      selected = selected.filter(item => item !== field);
    } else {
      //Select
      selected.push(field);
    }
    this.setState({ selected });
  };

  selectItem = field => {
    this.setState({ selected: [field] });
  };

  render() {
    const fields = options[this.props.field];
    const { t, color } = this.props;
    const styles = {
      title: {
        marginBottom: 10,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color
      },
      doneBtn: {
        width: '100%',
        backgroundColor: color,
        color: 'white',
        fontSize: 16,
        textAlign: 'center',
        marginTop: 20,
        borderRadius: 0,
        border: `1px solid ${color}`,
        marginTop: 20,
        position: 'absolute',
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        marginLeft: -24,
        height: 45
      }
    };

    return (
      <Modal
        footer={false}
        visible={this.props.open}
        onCancel={this.props.close}>
        <h3 style={styles.title}>{t(title[this.props.field])}</h3>
        {fields &&
          fields.map(item => (
            <div
              onClick={() =>
                this.props.mode == 'single'
                  ? this.selectItem(item)
                  : this.changeSelection(item)
              }
              style={this.getFieldStyle(item)}>
              {t(item)}
            </div>
          ))}
        <Button
          style={styles.doneBtn}
          onClick={() => this.props.confirm(this.state.selected)}>
          {t('Done')}
        </Button>
      </Modal>
    );
  }
}

export default MultipleSelect;

const options = {
  learnerProfile: [
    'Inquirers',
    'Knowledgeable',
    'Thinkers',
    'Communicators',
    'Principled',
    'Open-Minded',
    'Caring',
    'Risk-Takers',
    'Balanced',
    'Reflective'
  ],
  serviceLearning: [
    'become more aware of their own strengths and areas for growth',
    'undertake challenges that develop new skills',
    'discuss, evaluate and plan student-initiated activities',
    'show commitment to and persevere in action',
    'work collaboratively with others',
    'develop international-mindedness through global engagement, multilingualism and intercultural understanding',
    'recognise and consider the ethical implications of my actions'
  ],
  type: ['Direct Service', 'Indirect Service', 'Advocacy', 'Research'],
  categories: [
    'Research',
    'Thinking',
    'Self-Management',
    'Social',
    'Communication'
  ],
  need: ['Media', 'Interview', 'Survey', 'Observation']
};

const title = {
  learnerProfile: 'Learner profile attributes',
  serviceLearning: 'Relevant Service Learning Outcomes',
  type: 'Type of Project',
  categories: 'Skills',
  need:
    'How do you know that this need really exists? What research did you carry out to authenticate the need?'
};



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/multipleSelect.js